__webpack_require__.p = "https://sms.securitas.com.tr/";